import { render, staticRenderFns } from "./video-lectures.vue?vue&type=template&id=798c6661&scoped=true"
import script from "./video-lectures.vue?vue&type=script&lang=js"
export * from "./video-lectures.vue?vue&type=script&lang=js"
import style0 from "./video-lectures.vue?vue&type=style&index=0&id=798c6661&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798c6661",
  null
  
)

export default component.exports